import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  QueryList,
  Signal,
  signal,
  TemplateRef,
  ViewChildren,
} from '@angular/core';

@Component({
  selector: 'pm-pages-navigator',
  imports: [],
  templateUrl: './pm-pages-navigator.component.html',
  styleUrl: './pm-pages-navigator.component.scss',
})
export class PmPagesNavigatorComponent implements AfterViewInit {
  @Input({ required: true }) pages!: TemplateRef<any>[];
  @Output() scrollToSlide = new EventEmitter();
  @ViewChildren('dot') dots!: QueryList<ElementRef<HTMLDivElement>>;
  private readonly _ACTIVE_DOT_CLASS = 'active';

  ngAfterViewInit() {
    const firstDot = this.dots.first;
    firstDot.nativeElement.classList.add(this._ACTIVE_DOT_CLASS);
  }

  scrollToPage(index: number) {
    this.scrollToSlide.emit(index);
  }

  updateDotsStatus(currentSlide: number) {
    this.dots.forEach((dotRef, index) => {
      const dot = dotRef.nativeElement;
      if (index === currentSlide) {
        dot.classList.add(this._ACTIVE_DOT_CLASS);
      } else {
        dot.classList.remove(this._ACTIVE_DOT_CLASS);
      }
    });
  }
}
